import { stimulusApp } from './application.js'
import AdvizePendingActionController from './advize_pending_action_controller.js'
import CarouselController from './carousel_controller.js'
import ChartsSwitcherController from './charts_switcher_controller.js'
import CheckboxFilterController from './checkbox_filter_controller.js'
import CurrencyToggleController from './currency_toggle_controller.js'
import DashboardChartsController from './dashboard_charts_controller.js'
import DoughnutChartController from './doughnut_chart_controller.js'
import EsgToggleController from './esg_toggle_controller.js'
import ExportChannelController from './export_channel_controller.js'
import ExportButtonController from './export_button_controller.js'
import FormatSelectController from './format_select_controller.js'
import FormCompletenessController from './form_completeness_controller.js'
import FormValidationController from './form_validation_controller.js'
import GtmEventController from './gtm_event_controller.js'
import InvestmentExperienceController from './investment_experience_controller.js'
import InviteInvestorController from './invite_investor_controller.js'
import LowOperationWarningController from './low_operation_warning_controller.js'
import LegalEntityNifController from './legal_entity_nif_controller.js'
import ModalController from './modal_controller.js'
import NavbarController from './navbar_controller.js'
import NotificationsController from './notifications_controller.js'
import OrderedCheckboxesController from './ordered_checkboxes_controller.js'
import PasswordVisibilityController from './password_visibility_controller.js'
import PatrimonyController from './patrimony_controller.js'
import PayinController from './payin_controller.js'
import PdfViewerController from './pdf_viewer_controller.js'
import PepDescriptionController from './pep_description_controller.js'
import PepMandateController from './pep_mandate_controller.js'
import PepToggleController from './pep_toggle_controller.js'
import PhoneInputController from './phone_input_controller.js'
import PreventEnterSubmitController from './prevent_enter_submit_controller.js'
import ProfileCompletionController from './profile_completion_controller.js'
import ProfileMenuController from './profile_menu_controller.js'
import ScaConsentCallbackController from './sca_consent_callback_controller.js'
import ScrollActiveIntoViewController from './scroll_active_into_view_controller.js'
import ScrollFocusedIntoViewController from './scroll_focused_into_view_controller.js'
import SimulatorV2Controller from './simulator_v2_controller.js'
import SmartInvestAnnouncementController from './smart_invest_announcement_controller'
import StickySubscribeController from './sticky_subscribe_controller.js'
import SubscriptionConfirmationController from './subscription_confirmation_controller.js'
import SubscriptionsFilterController from './subscriptions_filter_controller.js'
import TaxationController from './taxation_controller.js'
import TaxLocationController from './tax_location_controller.js'
import ToastDemoController from './toast_demo_controller.js'
import UboCardController from './ubo_card_controller.js'
import UboFormController from './ubo_form_controller.js'

// Register controllers
stimulusApp.register('advize-pending-action', AdvizePendingActionController);
stimulusApp.register('carousel', CarouselController);
stimulusApp.register('charts-switcher', ChartsSwitcherController);
stimulusApp.register('checkbox-filter', CheckboxFilterController);
stimulusApp.register('currency-toggle', CurrencyToggleController);
stimulusApp.register('dashboard-charts', DashboardChartsController);
stimulusApp.register('doughnut-chart', DoughnutChartController);
stimulusApp.register('esg-toggle', EsgToggleController);
stimulusApp.register('export-channel', ExportChannelController);
stimulusApp.register('export-button', ExportButtonController);
stimulusApp.register('format-select', FormatSelectController);
stimulusApp.register('form-completeness', FormCompletenessController);
stimulusApp.register('form-validation', FormValidationController);
stimulusApp.register('gtm-event', GtmEventController);
stimulusApp.register('investment-experience', InvestmentExperienceController);
stimulusApp.register('invite-investor', InviteInvestorController);
stimulusApp.register('low-operation-warning', LowOperationWarningController);
stimulusApp.register('legal-entity-nif', LegalEntityNifController);
stimulusApp.register('modal', ModalController);
stimulusApp.register('navbar', NavbarController);
stimulusApp.register('notifications', NotificationsController);
stimulusApp.register('ordered-checkboxes', OrderedCheckboxesController);
stimulusApp.register('password-visibility', PasswordVisibilityController);
stimulusApp.register('patrimony', PatrimonyController);
stimulusApp.register('payin', PayinController);
stimulusApp.register('pdf-viewer', PdfViewerController);
stimulusApp.register('pep-description', PepDescriptionController);
stimulusApp.register('pep-mandate', PepMandateController);
stimulusApp.register('pep-toggle', PepToggleController);
stimulusApp.register('phone-input', PhoneInputController);
stimulusApp.register('prevent-enter-submit', PreventEnterSubmitController);
stimulusApp.register('profile-completion', ProfileCompletionController);
stimulusApp.register('profile-menu', ProfileMenuController);
stimulusApp.register('sca-consent-callback', ScaConsentCallbackController);
stimulusApp.register('scroll-active-into-view', ScrollActiveIntoViewController);
stimulusApp.register('scroll-focused-into-view', ScrollFocusedIntoViewController);
stimulusApp.register('simulator-v2', SimulatorV2Controller);
stimulusApp.register('smart-invest-announcement', SmartInvestAnnouncementController);
stimulusApp.register('sticky-subscribe', StickySubscribeController);
stimulusApp.register('subscription-confirmation', SubscriptionConfirmationController);
stimulusApp.register('subscriptions-filter', SubscriptionsFilterController);
stimulusApp.register('taxation', TaxationController);
stimulusApp.register('tax-location', TaxLocationController);
stimulusApp.register('toast-demo', ToastDemoController);
stimulusApp.register('ubo-card', UboCardController);
stimulusApp.register('ubo-form', UboFormController);
